import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/render/project/src/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["MarketingPageShell"] */ "/opt/render/project/src/src/modules/landing/components/MarketingPageShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceDetailPage"] */ "/opt/render/project/src/src/modules/services/pages/ServiceDetailPage.tsx");
